import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { LockUnlockRecordsRoutingModule } from './lock-unlock-records-routing.module';
import { LockUnlockRecordsComponent } from './lock-unlock-records.component';
import { MatFormFieldModule } from '@angular/material/form-field';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatInputModule } from '@angular/material/input';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';

@NgModule({
  declarations: [
    LockUnlockRecordsComponent,
    
  ],
  imports: [
    CommonModule,
    LockUnlockRecordsRoutingModule,
    MatFormFieldModule,
    SharedModule,
    MatInputModule,
    ReactiveFormsModule,
    FormsModule
    
   
  ]
})
export class LockUnlockRecordsModule { }
